export default __webpack_public_path__ + "static/reauth_kyc-9bb32ca821647acdd3da3b7e5c8039e4.svg";